<div class="profile-address-form general-container flex flex-col justify-center items-center h-full">

  <!-- ==================== STEP 1: Tipo + Ubicación ==================== -->
  <div *ngIf="step === 1" class="w-full">
    <div class="form-header header mb-24">
      <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">Dirección</h2>
      <p class="font-sans text-center text-xl text-gray-40">
        Selecciona el tipo y la ubicación de tu dirección.
      </p>
    </div>

    <div class="form-body">
      <!-- Address Type Selector -->
      <div class="inp mb-32">
        <label class="block font-sans text-eggplant-80 text-l w-full mb-6">
          Tipo de dirección
        </label>
        <p class="font-sans text-eggplant-100/[0.5] text-s mb-8">
          Puedes seleccionar varios tipos si aplican a esta dirección
        </p>
        <div class="address-type-grid grid grid-cols-2 md:grid-cols-3 gap-8">
          <div *ngFor="let type of addressTypes" class="form-input checkbox !mt-0 !mb-0">
            <input type="checkbox" [id]="'addressType_' + type.id" [checked]="isTypeSelected(type.id)"
              (change)="toggleType(type.id)">
            <label [for]="'addressType_' + type.id" class="!text-eggplant-100/[0.55]">{{ type.name }}</label>
          </div>
        </div>
        <p *ngIf="isSubmit && selectedTypes.length === 0" class="font-sans text-alert text-s mt-4">
          Selecciona al menos un tipo de dirección
        </p>
      </div>

      <!-- Country Toggle -->
      <div class="inp mb-16">
        <label class="block font-sans text-eggplant-80 text-l w-full mb-6">
          Ubicación
        </label>
        <div class="flex flex-col gap-12">
          <div class="question cursor-pointer w-full flex gap-32 justify-between" (click)="toggleCountryType(true)"
            [ngClass]="{'option-selected': isNationalResidence, 'option': !isNationalResidence}">
            <div class="flex flex-col py-12 px-24 gap-4">
              <h4 class="font-sans text-xl text-eggplant-80">España</h4>
              <p class="font-sans text-l text-gray-40">Dirección dentro del territorio nacional</p>
            </div>
          </div>
          <div class="question cursor-pointer w-full flex gap-32 justify-between" (click)="toggleCountryType(false)"
            [ngClass]="{'option-selected': !isNationalResidence, 'option': isNationalResidence}">
            <div class="flex flex-col py-12 px-24 gap-4">
              <h4 class="font-sans text-xl text-eggplant-80">Internacional</h4>
              <p class="font-sans text-l text-gray-40">Dirección fuera de España</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Country Selector (International only) -->
      <div class="inp mb-16" *ngIf="!isNationalResidence">
        <fun-input *ngIf="!isMobile" placeholder="Selecciona un país" [parentForm]="addressForm"
          [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
          controlName="country" type="select" [errorLogin]="errorAmount" labelName="País" [items]="countriesList"
          [selectedItem]="addressForm.get('country').value"></fun-input>
        <form *ngIf="isMobile" [formGroup]="addressForm">
          <div class="inp select form-input">
            <label class="block font-sans text-eggplant-80 text-l w-full mb-6">País</label>
            <select
              class="select-box w-full py-12 px-12 border border-eggplant-75 rounded bg-white font-sans text-eggplant-80"
              formControlName="country">
              <option hidden [value]="null">Selecciona un país</option>
              <option *ngFor="let country of countriesList" [value]="country.id">
                {{ country.name }}
              </option>
            </select>
          </div>
        </form>
        <p *ngIf="isSubmit && !addressForm.get('country').value" class="font-sans text-alert text-s mt-4">
          Campo obligatorio
        </p>
      </div>
    </div>
  </div>

  <!-- ==================== STEP 2: Formulario de dirección ==================== -->
  <div *ngIf="step === 2" class="w-full">
    <div class="form-header header mb-24">
      <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">Dirección</h2>
      <p class="font-sans text-center text-xl text-gray-40">
        Introduce los datos de tu dirección.
      </p>
    </div>

    <div class="form-body">
      <!-- Autocomplete Mode (National only) -->
      <div *ngIf="isNationalResidence && autocompleteMode" class="mb-16">
        <div class="inp">
          <fun-input placeholder="Ej: Calle Mayor, 1, Madrid" [parentForm]="addressForm"
            [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
            controlName="addressAutocomplete" [id]="'addressAutocomplete'" type="text" [errorLogin]="errorAmount"
            labelName="Dirección" (addressPlaced)="getAddress($event)" [isDesktop]="desktopApp"></fun-input>
        </div>
        <p class="font-sans text-eggplant-100/[0.5] text-s mt-8">
          ¿Prefieres introducir la dirección manualmente?
          <span class="text-orange-100 cursor-pointer underline" (click)="switchAutocomplete(false)">Haz clic
            aquí</span>
        </p>
      </div>

      <!-- Manual Mode -->
      <div *ngIf="!autocompleteMode || !isNationalResidence">
        <!-- Address Input -->
        <div class="inp mb-16">
          <fun-input placeholder="Ej: Calle Mayor, 1" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
            [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="address" type="text"
            [errorLogin]="errorAmount" labelName="Dirección"></fun-input>
        </div>

        <!-- Postal Code -->
        <div class="inp mb-16">
          <fun-input placeholder="Código postal" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
            [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="postalCode" type="text"
            [errorLogin]="errorAmount" labelName="Código postal"></fun-input>
        </div>

        <!-- National: Region and City -->
        <div *ngIf="isNationalResidence">
          <div class="inp mb-16">
            <fun-input *ngIf="!isMobile" placeholder="Selecciona una provincia" [parentForm]="addressForm"
              [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
              controlName="region" type="select" [errorLogin]="errorAmount" labelName="Provincia"
              (selectChange)="onRegionChange()" [items]="regionList"
              [selectedItem]="addressForm.get('region').value"></fun-input>
            <form *ngIf="isMobile" [formGroup]="addressForm">
              <div class="inp select form-input">
                <label class="block font-sans text-eggplant-80 text-l w-full mb-6">Provincia</label>
                <select
                  class="select-box w-full py-12 px-12 border border-eggplant-75 rounded bg-white font-sans text-eggplant-80"
                  formControlName="region" (change)="onRegionChange()">
                  <option hidden [value]="null">Selecciona una provincia</option>
                  <option *ngFor="let region of regionList" [value]="region.id">
                    {{ region.name }}
                  </option>
                </select>
              </div>
            </form>
            <p *ngIf="isSubmit && !addressForm.get('region').value" class="font-sans text-alert text-s mt-4">
              Campo obligatorio
            </p>
          </div>

          <div class="inp mb-16" *ngIf="townList.length > 0">
            <fun-input *ngIf="!isMobile" placeholder="Selecciona una población" [parentForm]="addressForm"
              [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
              controlName="city" type="select" [errorLogin]="errorAmount" labelName="Población" [items]="townList"
              [selectedItem]="addressForm.get('city').value"></fun-input>
            <form *ngIf="isMobile" [formGroup]="addressForm">
              <div class="inp select form-input">
                <label class="block font-sans text-eggplant-80 text-l w-full mb-6">Población</label>
                <select
                  class="select-box w-full py-12 px-12 border border-eggplant-75 rounded bg-white font-sans text-eggplant-80"
                  formControlName="city">
                  <option hidden [value]="null">Selecciona una población</option>
                  <option *ngFor="let town of townList" [value]="town.id">
                    {{ town.name }}
                  </option>
                </select>
              </div>
            </form>
            <p *ngIf="isSubmit && !addressForm.get('city').value" class="font-sans text-alert text-s mt-4">
              Campo obligatorio
            </p>
          </div>

          <div class="inp mb-16" *ngIf="townList.length === 0 && addressForm.get('region').value && !loading">
            <fun-input placeholder="Población" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
              [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="city" type="text"
              [errorLogin]="errorAmount" labelName="Población"></fun-input>
          </div>

          <p class="font-sans text-eggplant-100/[0.5] text-s mb-16">
            ¿Prefieres buscar tu dirección con Google?
            <span class="text-orange-100 cursor-pointer underline" (click)="switchAutocomplete(true)">Haz clic
              aquí</span>
          </p>
        </div>

        <!-- International: Region and City -->
        <div *ngIf="!isNationalResidence">
          <div class="inp mb-16">
            <fun-input placeholder="Provincia / Región" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
              [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="internationalRegion" type="text"
              [errorLogin]="errorAmount" labelName="Provincia / Región"></fun-input>
          </div>

          <div class="inp mb-16">
            <fun-input placeholder="Ciudad" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
              [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="internationalCity" type="text"
              [errorLogin]="errorAmount" labelName="Ciudad"></fun-input>
          </div>
        </div>
      </div>

      <!-- Loading ciudades -->
      <div *ngIf="loading" class="flex justify-center py-16">
        <fun-spinner></fun-spinner>
      </div>
    </div>
  </div>

  <!-- ==================== STEP 3: Declaración responsable ==================== -->
  <div *ngIf="step === 3" class="w-full">
    <div class="form-header header mb-24">
      <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">Confirmación</h2>
      <p class="font-sans text-center text-xl text-gray-40">
        Revisa y confirma la información de tu dirección.
      </p>
    </div>

    <div class="form-body">
      <div class="legal-container bg-cream-100/[0.08] rounded-xl p-24 mb-24">
        <p class="font-sans text-eggplant-100 text-m mb-16">
          De conformidad con la normativa vigente en materia de prevención de blanqueo de capitales y financiación del
          terrorismo, declaro que los datos de dirección proporcionados son veraces y se corresponden con mi domicilio
          real.
        </p>
        <p class="font-sans text-eggplant-100/[0.7] text-s mb-16">
          Fundeen podrá requerirle documentación adicional para verificar la veracidad de la información proporcionada.
          En caso de detectarse información incorrecta o fraudulenta, Fundeen se reserva el derecho de suspender o
          cancelar su cuenta de usuario.
        </p>
        <p class="font-sans text-eggplant-100/[0.7] text-s">
          Es su responsabilidad mantener actualizada la información de sus direcciones. Cualquier cambio en su
          domicilio deberá ser comunicado a la mayor brevedad posible.
        </p>
      </div>

      <div class="form-input checkbox">
        <input type="checkbox" id="legalAcceptance" [checked]="legalAccepted" (change)="toggleLegal()">
        <label for="legalAcceptance" class="font-sans text-eggplant-100 text-m">
          Declaro que la información proporcionada es correcta y me responsabilizo de su veracidad.
        </label>
      </div>
      <p *ngIf="legalError && !legalAccepted" class="font-sans text-alert text-s mt-4">
        Debes aceptar la declaración responsable para continuar
      </p>
    </div>
  </div>

  <!-- ==================== STEP 4: Loader ==================== -->
  <div *ngIf="step === 4" class="w-full flex flex-col items-center justify-center py-64">
    <fun-spinner></fun-spinner>
    <p class="font-sans text-eggplant-100/[0.6] text-l mt-24">Guardando dirección...</p>
  </div>

  <!-- ==================== STEP 5: Resultado ==================== -->
  <div *ngIf="step === 5" class="w-full flex flex-col items-center justify-center py-48">
    <div class="w-64 h-64 rounded-full flex items-center justify-center mb-24">
      <fun-icon [name]="'check-circle'" [style]="'w-64 h-64 stroke-[2px] stroke-orange-100'"></fun-icon>
    </div>
    <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">Dirección guardada</h2>
    <p class="font-sans text-center text-xl text-gray-40 mb-32">{{ successMessage }}</p>
    <fun-new-button [size]="'xl'" [buttonType]="'primaryDark'" (eventClick)="onCancel()" title="Aceptar"
      [classExtra]="' !w-full max-w-[300px] '"></fun-new-button>
  </div>

  <!-- ==================== STEP 6: Error ==================== -->
  <div *ngIf="step === 6" class="w-full flex flex-col items-center justify-center py-48">
    <div class="w-64 h-64 rounded-full flex items-center justify-center mb-24">
      <fun-icon [name]="'user-x'" [style]="'w-64 h-64 stroke-[2px] stroke-orange-100'"></fun-icon>
    </div>
    <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">Error</h2>
    <p class="font-sans text-center text-xl text-gray-40 mb-32">Ha ocurrido un error al guardar la dirección. Por favor,
      inténtalo de nuevo.</p>
    <fun-new-button [size]="'xl'" [buttonType]="'primaryDark'" (eventClick)="retryFromError()" title="Reintentar"
      [classExtra]="' !w-full max-w-[300px] '"></fun-new-button>
  </div>

</div>

<!-- Footer -->
<div *ngIf="step <= 3"
  class="footer form-actions sticky bottom-0 bg-white p-24 border-t border-eggplant-100/[0.1] z-10 flex flex-col-reverse md:flex-row justify-between gap-12">

  <!-- Botón izquierdo: Cancelar (step 1) o Atrás (steps 2-3) -->
  <div class="w-full md:w-fit md:flex justify-center">
    <fun-new-button *ngIf="step === 1" [size]="'xl'" [buttonType]="'ghost'" (eventClick)="onCancel()" title="Cancelar"
      [classExtra]="' !w-full '"></fun-new-button>
    <fun-new-button *ngIf="step > 1" [size]="'xl'" [buttonType]="'ghost'" (eventClick)="prevStep()" title="Atrás"
      [classExtra]="' !w-full '"></fun-new-button>
  </div>

  <!-- Botón derecho: Siguiente (steps 1-2) o Confirmar (step 3) -->
  <div class="w-full md:w-fit md:flex justify-center">
    <fun-new-button *ngIf="step === 1" [size]="'xl'" [buttonType]="'primaryDark'" (eventClick)="goToStep2()"
      title="Siguiente" [classExtra]="' !w-full '"></fun-new-button>
    <fun-new-button *ngIf="step === 2" [size]="'xl'" [buttonType]="'primaryDark'" (eventClick)="goToStep3()"
      title="Siguiente" [classExtra]="' !w-full '"></fun-new-button>
    <fun-new-button *ngIf="step === 3" [size]="'xl'" [buttonType]="'primaryDark'" (eventClick)="onSubmit()"
      title="Confirmar" [classExtra]="' !w-full '"></fun-new-button>
  </div>
</div>